import { render, staticRenderFns } from "./RowMinus.vue?vue&type=template&id=4be671b0"
import script from "./RowMinus.vue?vue&type=script&lang=js"
export * from "./RowMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports